// extracted by mini-css-extract-plugin
module.exports = {"location":"AutoComplete_location__3MAIB","suggestionList":"AutoComplete_suggestionList__1hZdl","list":"AutoComplete_list__10vI0","subText":"AutoComplete_subText__2M8H6"};